import React from 'react'
import style from '../scss/components/VideoPlayer.module.scss'
import PlayButton from './PlayButton'
import {useSelector} from 'react-redux'
import videoSmallBgImg from '../assets/video-bg-small.png'
import videoSmallBgImg2x from '../assets/video-bg-small@2x.png'
import videoSmallBgImg3x from '../assets/video-bg-small@3x.png'
import videoBgImg from '../assets/video-bg.png'
import videoBgImg2x from '../assets/video-bg@2x.png'
import videoBgImg3x from '../assets/video-bg@3x.png'
import ReactPlayer from "react-player"
import classNames from "classnames"

type Props = {
    url: string
    placeholderVideoUrl: string
    playing: boolean
    paused: boolean
    onVideoPlay: () => void
    onVideoPause?: () => void
    showBgImage?: boolean
}

const VideoPlayer = ({url, placeholderVideoUrl, playing, paused, onVideoPlay, onVideoPause, showBgImage}: Props) => {
    // @ts-ignore
    const width = useSelector(state => state.window.width)

    const renderVideoPlayer = () => {
        return (
            <div className={classNames(style.VideoPlayer, {
                [style.ShowVideo]: playing || paused
            })}>
                <ReactPlayer
                    config={{
                        vimeo: {
                            playerOptions: {
                                color: '4f1cd8',
                                playsinline: false,
                                title: false,
                                byline: false,
                            },
                        },
                    }}
                    width={'100%'}
                    height={'100%'}
                    controls={true}
                    playing={playing}
                    url={url}
                    onPause={onVideoPause}
                    onPlay={onVideoPlay}
                />
            </div>
        )
    }

    if (width > 500) {
        return (
            <div className={classNames(style.VideoContainerOuter, {
                [style.NoBgImg]: !showBgImage,
                [style.Playing]: playing
            })}>
                {showBgImage &&
                    <img src={videoBgImg}
                         srcSet={`${videoBgImg2x} 2x, ${videoBgImg3x} 3x`}
                         alt={''}
                         className={style.VideoBg}
                    />
                }
                <div className={classNames(style.VideoContainerInner, {
                    [style.ShowVideoPlaceholder]: !playing && !paused
                })} onClick={onVideoPlay}>
                    {renderVideoPlayer()}
                    {(!playing && !paused) &&
                        <video
                            controls={false}
                            autoPlay={true}
                            muted={true}
                            playsInline={true}
                            src={placeholderVideoUrl}
                            typeof={'video/mp4'}
                            loop={true}
                        />
                    }
                    {/*<img src={videoPlaceholderImg}
                         srcSet={`${videoPlaceholderImg2x} 2x, ${videoPlaceholderImg3x} 3x`}
                         alt={''}
                         className={classNames(style.VideoPlaceholder, {
                             [style.HideBg]: playing || paused
                         })}
                    />*/}
                    {(paused) && <PlayButton/>}
                </div>
            </div>
        )
    } else {
        return (
            <div className={classNames(style.VideoContainerOuter, {
                [style.NoBgImg]: !showBgImage
            })}>
                {showBgImage &&
                    <img src={videoSmallBgImg}
                         srcSet={`${videoSmallBgImg2x} 2x, ${videoSmallBgImg3x} 3x`}
                         alt={''}
                         className={style.VideoBg}
                    />
                }
                <div className={classNames(style.VideoContainerInner, {
                    [style.ShowVideoPlaceholder]: !playing && !paused
                })} onClick={onVideoPlay}>
                    {renderVideoPlayer()}
                    {(!playing && !paused) &&
                        <video
                            controls={false}
                            autoPlay={true}
                            muted={true}
                            playsInline={true}
                            src={placeholderVideoUrl}
                            typeof={'video/mp4'}
                            loop={true}
                        />
                    }
                    {(paused) && <PlayButton/>}
                </div>
            </div>
        )
    }
}

VideoPlayer.defaultProps = {
    playing: false,
    paused: false,
    showBgImage: true
}

export default VideoPlayer
